// src/utils/specStatus.js
//
// Single source of truth for the Customer Spec lifecycle status: the ordered label
// set, a sort rank, and per-status colors. Mirrors the gradeColor.js pattern but
// consumes the var(--…) status tokens from styles/tokens.js (never raw literals).
//
// Only `Active` is visible in the read-only Index (enforced server-side). The other
// three are editor-facing states. Colors pair a background token with a legible
// foreground: white on the darker green/grey/red, near-black on orange (white on
// orange-500 fails WCAG AA, ~2.6:1).

export const SPEC_STATUSES = ['Active', 'Pending Approval', 'Draft', 'Inactive'];

// The user-facing default when creating a spec in the Entry Form.
export const DEFAULT_SPEC_STATUS = 'Draft';

const STATUS_STYLE = {
  'Active':           { bg: 'var(--color-status-active)',   fg: 'var(--white)' },
  'Pending Approval': { bg: 'var(--color-status-pending)',  fg: 'var(--color-text)' },
  'Draft':            { bg: 'var(--color-status-draft)',    fg: 'var(--white)' },
  'Inactive':         { bg: 'var(--color-status-inactive)', fg: 'var(--white)' },
};

// Normalize a stored/raw value to a known label. Unknown or empty → 'Active',
// matching the server's read-time ISNULL(Status,'Active') fail-open behavior.
export function normalizeStatus(value) {
  const s = String(value == null ? '' : value).trim();
  return SPEC_STATUSES.includes(s) ? s : 'Active';
}

// { bg, fg } CSS custom-property tokens for a status chip.
export function statusColor(label) {
  return STATUS_STYLE[normalizeStatus(label)];
}

// Lifecycle order for sorting (Active first → Inactive last).
export function statusRank(label) {
  return SPEC_STATUSES.indexOf(normalizeStatus(label));
}
